export const addCorporateSigners = () => {

  const signerFields = () => {
    const $emptySigners = document.querySelectorAll('.js-required-input');
    let $signerButton = document.querySelector('.js-btn');

    const validInputs = () => {
      let status = true;

      $emptySigners.forEach(field => {
        if (field.value.trim() == 0) {
          status = false;
        }
      })

      if (status) {
        $signerButton.classList.remove("disabled");
      } else {
        $signerButton.classList.add("disabled");
      }
    }

    $emptySigners.forEach(field => {
      field.addEventListener("keyup", validInputs);
    });
  }

  let $addSignerButton = document.querySelector('.btn-add-signer');

  $addSignerButton.addEventListener("click", (event) => {
    let $emptySigners = document.querySelectorAll('.js-required-input-extra');
    enableExtraInputs();
  });

  const disableSignerBtn = () => {
    let $signersContainer = document.querySelector('.signers-container.signer-disabled');
    if ($signersContainer == null) {
      document.querySelector('.btn-add-signer').classList.add("disabled");

      return true;
    }
    document.querySelector('.btn-add-signer').classList.remove("disabled");
  }

  const clearInputs = () => {
    let $inputs = document.querySelectorAll('.signer-disabled .js-required-input-extra');

    if ($inputs.length == 0) {
      return true;
    }
    $inputs.forEach(field => {
      field.value = '';
    });
  }

  const removeInputs = () => {
    let $removeSignerInputs = document.querySelectorAll('.js-remove-input');

    $removeSignerInputs.forEach(field => {
      field.addEventListener("click", (event) => {
        let $parent = event.target.parentNode.parentNode;
        $parent.classList.add('signer-disabled');
        document.querySelector('.btn-add-signer').classList.remove('disabled');
        clearInputs()
      });
    });
  }

  const enableExtraInputs = () => {
    let $signersContainer = document.querySelector('.signers-container.signer-disabled');

    if ($signersContainer == null) {
      return true;
    }
    $signersContainer.classList.remove("signer-disabled");
    disableSignerBtn();
  }

  signerFields();
  removeInputs();
}
